import React, { Component } from "react";
import { connect } from "react-redux";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { ReactComponent as Error } from "../../CheckoutProcess/assets/close.svg";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { Lightbox } from "react-modal-image";
import ZoomInIcon from "@material-ui/icons/ZoomIn";
import { getCurrencyIcon } from "../../../Helpers/currencyConverter";

class ProductFileField extends Component {
  inputRef = React.createRef();
  state = {
    filename: this.props.selectedExtraField?.value || undefined,
    errorOpen: false,
    errorMessage: "",
    errorMessageArabic: "",
    openExampleImage: false,
  };

  handleFileUpload = async (e) => {
    const { selectedExtraField } = this.props;
    const file = e.target.files[0];
    if (!file) return;
    const fileExtension = file.name.split(".").pop().toLowerCase();
    const allowableExtensions = [
      "txt",
      "jpg",
      "jpeg",
      "bmp",
      "png",
      "doc",
      "docx",
      "odt",
      "pdf",
      "xls",
      "xlsx",
      "ods",
      "ppt",
      "pptx",
      "rar",
      "zip",
      "zipx",
      "7z",
      "csv",
      "mp3",
      "wav",
      "m4a",
      "flac",
      "aac",
      "ogg",
      "wma",
      "aiff",
      "aif",
      "ape",
      "midi",
      "mid",
      "amr",
      "ac3",
      "caf",
      "au",
    ];

    if (!allowableExtensions.includes(fileExtension)) {
      this.inputRef.current.value = "";
      this.setState({
        errorOpen: true,
        errorMessage: "Invalid file format",
        errorMessageArabic: "نوع الملف غير مدعم",
      });
      return;
    }

    if (file.size / 1024 / 1024 > 10) {
      this.inputRef.current.value = "";
      this.setState({
        errorOpen: true,
        errorMessage: "File must be smaller than 10 MB",
        errorMessageArabic: "حجم الملف يجب ان يكون أصغر من 10 ميجا",
      });
      return;
    }

    this.props.setExtrafield(this.props.extraField, file, this.props.groupID);
    const hasError = selectedExtraField?.error;
    if (hasError) {
      selectedExtraField.error = false;
    }
    this.setState({ filename: file.name });
  };
  removeFile = () => {
    this.inputRef.current.value = null;
    this.props.setExtrafield(this.props.extraField, null, this.props.groupID);
    this.setState({ filename: undefined });
  };
  componentDidUpdate = () => {
    const hasError = this.props.selectedExtraField?.error;
    const errorType = this.props.selectedExtraField?.errorType;
    if (hasError && this.state.filename) {
      if (errorType === "fail") {
        this.setState({
          errorOpen: true,
          errorMessageArabic: "لا يمكن إرفاق هذا الملف",
          errorMessage: "File could not be uploaded",
        });
      }
      this.removeFile();
    }
  };
  handleErrorClose = () => {
    this.setState({ errorOpen: "" });
  };
  render() {
    const {
      extraField,
      language,
      selectedExtraField,
      themeColor,
      settings,
      extraID,
    } = this.props;
    const { errorOpen, errorMessage, errorMessageArabic } = this.state;

    const filename = this.state.filename || undefined;
    const hasError = selectedExtraField?.error;
    const errorType = selectedExtraField?.errorType;
    const currencyIcon = getCurrencyIcon(settings)
    return (
      <div
        id={"extraField" + extraID}
        className="border mt-4 pt-3"
        style={{
          backgroundColor: "white",
          width: "100%",
          minHeight: 96,
        }}
      >
        {extraField.image && this.state.openExampleImage && (
          <div>
            <Lightbox
              hideDownload
              medium={extraField.image}
              large={extraField.image}
              alt={language === "arabic" ? extraField.ar_name : extraField.name}
              onClose={() => this.setState({ openExampleImage: false })}
            />
          </div>
        )}
        <Snackbar
          style={{ bottom: 70 }}
          open={errorOpen}
          autoHideDuration={6000}
          onClose={this.handleErrorClose}
        >
          <MuiAlert
            elevation={6}
            variant="filled"
            onClose={this.handleErrorClose}
            severity="error"
          >
            {(language === "arabic" && errorMessageArabic) || errorMessage}
          </MuiAlert>
        </Snackbar>
        <div
          className="mx-3"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexDirection: language === "arabic" && "row-reverse",
          }}
        >
          <div
            style={{
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "normal",
              direction: language == "arabic" ? "rtl" : "ltr",
            }}
            className={"text-muted ".concat(
              this.props.language === "english" ? "text-left" : "text-right"
            )}
          >
            {extraField.image && extraField.image_style == "avatar" && (
              <>
                <ZoomInIcon
                  onClick={() => this.setState({ openExampleImage: true })}
                  style={{
                    position: "absolute",

                    color: themeColor,
                    fontSize: 25,
                    padding: 2,
                    backgroundColor: "hsla(0,0%,100%,.8)",

                    borderRadius: 5,
                  }}
                />
                <img
                  onClick={() => this.setState({ openExampleImage: true })}
                  style={{
                    objectFit: "contain",
                    padding: 5,
                    paddingLeft: language == "english" ? 0 : null,
                    paddingRight: language == "english" ? null : 0,

                    width: 60,
                    height: 60,
                    borderRadius: 10,
                  }}
                  src={extraField.image}
                />
              </>
            )}
            <span>
              {(language === "arabic" && extraField.ar_name) || extraField.name}
            </span>
            {extraField.image && extraField.image_style == "icon" && (
              <>
                {"    "}
                <InfoOutlinedIcon
                  style={{ color: themeColor, cursor: "pointer", width: 18 }}
                  onClick={() => this.setState({ openExampleImage: true })}
                />
              </>
            )}
          </div>
          {extraField.price > 0 && (
            <div
              style={{
                color: themeColor,
                fontWeight: "bold",
                whiteSpace: "nowrap",
              }}
              className={`${language === "arabic" ? "mt-2" : "mb-2"}`} // Add margin to separate name and price
            >
              {extraField.price && " + "}
              <span
                className={currencyIcon}
              >
                {extraField.price
                  ? `${
                      language === "arabic"
                        ? settings.currency_local
                        : settings.currency_english
                    } ${extraField.price?.toFixed(settings.currency_decimals)}`
                  : (0).toFixed(settings.currency_decimals)}
              </span>
            </div>
          )}
        </div>
        <div
          style={{
            position: "relative",
            width: "100%",
            marginBlock: 16,
            paddingInline: 14,
            justifySelf: "center",
            display: "flex",

            gap: 5,
          }}
        >
          <input
            ref={this.inputRef}
            id={"extraInput" + extraID}
            onChange={this.handleFileUpload}
            style={{ display: "none" }}
            multiple
            type="file"
          />
          <label
            className="pointer"
            htmlFor={"extraInput" + extraID}
            style={{
              position: "relative",

              textAlign: language === "english" ? "left" : "right",
              zIndex: "1",
            }}
          >
            <Button
              style={{ textTransform: "none", width: "95px" }}
              className="p-1 "
              variant="contained"
              color="primary"
              component="span"
            >
              {language === "english" ? "Choose file" : "إختار ملف"}
            </Button>
          </label>

          <TextField
            style={{ pointerEvents: "none" }}
            id={"additionalTextField" + extraID}
            color="primary"
            key={"additionalKey" + extraID}
            name={"additional" + extraID}
            fullWidth
            placeholder={language === "english" ? "Choose file" : "إختار ملف"}
            error={hasError}
            value={
              hasError && errorType === "requirements"
                ? language === "arabic"
                  ? "هذه الخانة مطلوبة"
                  : "This field is required"
                : filename || ""
            }
            InputLabelProps={{
              style: {
                color: "red",
                right: language == "arabic" && 5,
                left: language == "english" ? 25 : 0,
              },
              dir: language == "english" ? "ltr" : "rtl",
            }}
            InputProps={{
              style: {
                color: hasError && "red",
              },

              dir: language == "english" ? "ltr" : "rtl",
              inputProps: { style: { width: "90%" } },
            }}
          />
          {filename && (
            <DeleteForeverIcon
              className="pointer"
              width={25}
              height={25}
              onClick={() => this.removeFile()}
              style={{
                position: "relative",
                float: language === "english" ? "right" : "left",

                cursor: "pointer",
                color: "#ff4242",
              }}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    themeColor: state.store.store.settings.dark || "#0099cc",
    settings: state.store.store.settings,
  };
};

export default connect(mapStateToProps)(ProductFileField);
